import { weightProp, alignProp, trimProp } from "../../../helpers";
import type { PropDef } from "../../../helpers";

const variants = [
  "small",
  "base",
  "paragraph",
  "subheading",
  "lead1",
  "lead2",
] as const;

const textPropDefs = {
  variant: { type: "enum", values: variants, default: "base" },
  weight: weightProp,
  align: alignProp,
  trim: trimProp,
} satisfies {
  variant: PropDef<(typeof variants)[number]>;
  weight: typeof weightProp;
  align: typeof alignProp;
  trim: typeof trimProp;
};

export { textPropDefs };
